module.exports = __webpack_public_path__ + "images/Exploring DAOs as a New Kind of Institution.pdf?v=42786abdcb1e40219c49527fbe60e873";